import React from "react";

import { Link, useNavigate, useParams } from "react-router-dom";
import { FaArrowLeft, FaMinus } from "react-icons/fa";
import axios from "axios";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import {
  Autocomplete,
  Box,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import HeaderName from "../HeaderName";
import SideBar from "../SideBar";
import { API_URL } from "../../../api/api";

function SpecialCommssionUpdate() {
  const token = localStorage.getItem("token");
  const url = API_URL();
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const [treatmentLists, setTreatmentLists] = useState([]);
  const [unitArr, setUnitArr] = useState([]);
  const [showUnitLists, setShowUnitLists] = useState([]);
  const [name, setName] = useState("");
  const [status, setStatus] = useState("");
  const [description, setDescription] = useState("");
  const [totalPrice, setTotalPrice] = useState("");
  const [sellingPrice, setSellingPrice] = useState(0);
  const [totalCost, setTotalCost] = useState("");
  const [doctorLists, setDoctorLists] = useState([]);
  const [doctorID, setDoctorID] = useState("");
  const [treatmentID, setTreatmentID] = useState("");
  const [commission, setCommission] = useState("");
  const [specialCommission, setSpecialCommission] = useState(null);
  const [commissionType, setCommissionType] = useState("");
  const [role, setRole] = useState("doctor");
  const [therapistLists, setTherapistLists] = useState([]);

  const { id } = useParams();

  const navigate = useNavigate();

  const [errors, setErrors] = useState({
    doctorID: "",
    treatmentID: "",
    commission: "",
  });
  console.log(showUnitLists);

  const SpecialCommissionUpdate = (event) => {
    event.preventDefault();

    let required = {};

    if (!commissionType) {
      required.commissionType = "Commission Type is required";
    }

    if (!commission) {
      required.commission = "Commission is required";
    }

    if (commissionType === "Percent" && commission > 100) {
      required.commission = "Percentage cannot exceed 100";
    }

    if (Object.keys(required).length > 0) {
      setErrors(required);
      return;
    }

    setErrors({
      commissionType: "",
      commission: "",
    });

    const data = {
      commissionAmount:
        commissionType === "Amount" || commissionType === "Percent"
          ? Number(commission)
          : 0,
      commissionType: commissionType,
    };

    const config = {
      headers: { "Content-Type": "application/json" },
    };

    api
      .put(`special-commission/${id}`, data, config)
      .then(function (response) {
        Swal.fire({
          title: "Success",
          text: "Successfully Updated!",
          icon: "success",
          confirmButtonText: "OK",
        });

        navigate("/special-commission");
      })
      .catch(function (err) {
        Swal.fire({
          title: "Error",
          text: err.response?.data?.message || "Something went wrong",
          icon: "error",
          confirmButtonText: "Cancel",
        });
      });

    setDoctorID("");
    setTreatmentID("");
    setCommission("");
  };

  const [searchKeyword, setSearchKeyword] = useState("");

  const handleTreatmentSearch = async (keyword) => {
    setSearchKeyword(keyword);
    try {
      const res = await api.get(`treatments?search=${keyword}`);
      setTreatmentLists(res.data.list);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const getSingleSpecialCommission = async () => {
      try {
        const res = await api.get(`special-commission/${id}`);

        const data = res.data.data;

        setSpecialCommission(data);

        if (data.relatedDoctor) {
          setRole("doctor");
          setDoctorID(data.relatedDoctor._id);
        } else if (data.relatedTherapist) {
          setRole("therapist");
          setDoctorID(data.relatedTherapist._id);
        }

        setDoctorID(data.relatedDoctor?._id || "");
        setTreatmentID(data.relatedTreatment?._id || "");
        setCommissionType(data.commissionType || "");
        setCommission(data.commissionAmount || "");
      } catch (err) {
        console.error(err);
      }
    };

    const getTreatment = async () => {
      try {
        const res = await api.get("treatments");

        setTreatmentLists(res?.data.list);
        setTreatmentID("");
        console.log(res?.data.list, "treat list");
      } catch (err) {}
    };

    const getDoctorLists = async () => {
      const res = await api.get("doctors");

      setDoctorLists(res.data.data);
      setDoctorID("");
    };

    const getTherapistLists = async () => {
      const res = await api.get("therapists");
      setTherapistLists(res.data.data);
    };

    getTherapistLists();
    getSingleSpecialCommission();
    getDoctorLists();
    getTreatment();
  }, []);

  return (
    <div classNameName="App">
      <div className="wrapper">
        <HeaderName />

        {/* <!-- /.navbar --> */}

        {/* <!-- Main Sidebar Container --> */}
        <SideBar />

        {/* <!-- Content Wrapper. Contains page content --> */}
        <div className="content-wrapper">
          <div className="container-fluid px-2">
            <div className="row mb-2">
              <div className="col-sm-12">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/special-commission">
                      <i>
                        <FaArrowLeft />
                      </i>
                    </Link>
                  </li>
                  <li className="breadcrumb-item active mt-1">
                    Special Commission Update
                  </li>
                </ol>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}
          <section className="content" style={{ paddingBottom: "1.5rem" }}>
            <div className="container-fluid px-4">
              <div class="card">
                <h4 className="px-4 pb-3 pt-4 fs-4">
                  Special Commission Update
                </h4>
                <div class="card-body pb-5 px-4">
                  {/* @if($com == null) */}
                  <form onSubmit={SpecialCommissionUpdate}>
                    {/* @csrf */}
                    <div className="form-body">
                      <div className="row">
                        <div className="col-md-3">
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="body2" sx={{ mb: 0.5 }}>
                              {role === "doctor"
                                ? "Related Doctor"
                                : "Related Therapist"}
                              <span style={{ color: "red" }}>*</span>
                            </Typography>
                            <TextField
                              fullWidth
                              size="small"
                              value={
                                role === "doctor"
                                  ? specialCommission?.relatedDoctor?.name || ""
                                  : specialCommission?.relatedTherapist?.name ||
                                    ""
                              }
                              disabled
                              InputProps={{ readOnly: true }}
                            />

                            {errors.doctorID && (
                              <div className="text-danger">
                                {errors.doctorID}
                              </div>
                            )}
                          </Box>
                        </div>
                        <div className="col-md-3">
                          <Typography variant="body2" sx={{ mb: 0.5 }}>
                            Related Treatment{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Typography>
                          <TextField
                            fullWidth
                            size="small"
                            value={
                              specialCommission?.relatedTreatment?.name || ""
                            }
                            disabled
                            InputProps={{ readOnly: true }}
                          />
                        </div>
                        <div className="col-md-2">
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="body2" sx={{ mb: 0.5 }}>
                              Is Percentage{" "}
                              <span style={{ color: "red" }}>*</span>
                            </Typography>
                            <div>
                              <label>
                                <input
                                  type="radio"
                                  name="commissionType"
                                  value="Percent"
                                  checked={commissionType === "Percent"}
                                  onChange={(e) =>
                                    setCommissionType(e.target.value)
                                  }
                                />
                                Yes
                              </label>
                              <label style={{ marginLeft: "10px" }}>
                                <input
                                  type="radio"
                                  name="commissionType"
                                  value="Amount"
                                  checked={commissionType === "Amount"}
                                  onChange={(e) =>
                                    setCommissionType(e.target.value)
                                  }
                                />
                                No
                              </label>
                            </div>

                            {errors.commissionType && (
                              <div className="text-danger">
                                {errors.commissionType}
                              </div>
                            )}
                          </Box>
                        </div>
                        <div className="col-md-3">
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="body2" sx={{ mb: 0.5 }}>
                              Commission <span style={{ color: "red" }}>*</span>
                            </Typography>
                            <TextField
                              fullWidth
                              size="small"
                              value={commission}
                              onChange={(e) => setCommission(e.target.value)}
                            />

                            {errors.commission && (
                              <div className="text-danger">
                                {errors.commission}
                              </div>
                            )}
                          </Box>
                        </div>
                      </div>

                      <div className="form-actions mt-3">
                        <div className="row">
                          <div className="col-md-12 d-flex justify-content-end">
                            <button type="submit" className="btn btn-primary">
                              Update
                            </button>
                            &nbsp;
                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={() => navigate("/special-commission")}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                  {/* <!-- /.row (main row) --> */}
                </div>
                {/*<!-- /.container-fluid --> */}
              </div>
            </div>
          </section>
        </div>
      </div>
      {/* <!-- /.content-wrapper --> */}
      <footer className="main-footer" style={{ marginTop: "50px;" }}>
        <strong>
          Copyright &copy; 2017-2020{" "}
          <a href="http://www.kwintechnologies.com">K-win Technology</a>.
        </strong>
        All rights reserved.
      </footer>

      {/* <!-- Control Sidebar --> */}
      <aside className="control-sidebar control-sidebar-dark">
        {/* <!-- Control sidebar content goes here --> */}
      </aside>

      {/* <!-- ./wrapper --> */}
    </div>
  );
}
export default SpecialCommssionUpdate;
